<div *ngIf="showWarning" class="small mb-3 form-text">{{ 'general.timezone' | translate: { timezone: timezoneString } }}</div>
